import { getUnknownErrorMessage } from '@caresend/utils';
import { reportException } from '../sentry.js';
import { openToast } from './helpers.js';

const toastResolve = (resolve, message, payload, options) => {
    openToast('is-success', message, options);
    resolve(payload);
};
const toastSuccess = (message, options) => {
    openToast('is-success', message, options);
};
const toastInfo = (message, options) => {
    openToast('is-info', message, options);
};
const toastReject = (reject, error, options) => {
    openToast('is-danger', error.message, options);
    reject(error);
};
/**
 * Displays an error toast and returns an error object. If `string` is passed,
 * the error is logged as is. If `Error | unknown` is passed, the message will
 * be extracted from the error object if possible.
 */
const toastError = (error, options) => {
    const message = typeof error === 'string' ? error : getUnknownErrorMessage(error);
    try {
        openToast('is-danger', message, options);
    }
    catch {
        // An error will be thrown if we are trying to display a toast before Vue
        // has initialized. If this happens, there is probably something very wrong
        // with our app. Fallback to alert, so the user still gets feedback that
        // something went wrong and can report the issue.
        // eslint-disable-next-line no-alert
        alert(message);
    }
    return new Error(message);
};
/**
 * Displays an error toast and reports it to Sentry. If a second argument is
 * passed it will be reported to Sentry instead of the first argument. This
 * allows us to show a friendly errorMessage to the user, but report the
 * technical exception to Sentry. The friendly errorMessage will still show in
 * the Sentry report in the breadcrumbs.
 *
 * Example:
 * ```
 * catch (error) {
 *  toastErrorAndReport(
 *     'Oopsie woopsie, something went wrong!',
 *     error,
 *  );
*  }
 * ```
 */
const toastErrorAndReport = (
/** Error to display to the user */
error, 
/** Error to submit to Sentry, but not display to the user. */
reportableError, options) => {
    // Call toastError first so breadcrumb is added.
    const errorFromToast = toastError(error, options);
    reportException(reportableError !== null && reportableError !== void 0 ? reportableError : error);
    return errorFromToast;
};

export { toastError, toastErrorAndReport, toastInfo, toastReject, toastResolve, toastSuccess };
